import { IApplicationState, TBoardId } from '../../../../../../../types/types';
import {
    getUserQualificationFormAnswers
} from '../../../../../../../store/model/authUser/selectors/getUserQualificationFormAnswers';
import { TEMPLATES_SETS } from '../../../constants';
import { isObject } from 'underscore';
import { TQualificationTemplatesSet } from '../../../types';
import {
    getUserQualificationFormStatus
} from '../../../../../../../store/model/authUser/selectors/getUserQualificationFormStatus';
import { EUserMetaQualificationFormStatus } from '../../../../../../../types/rest/IUserMeta';

export const getQualificationTemplateBoardIds = (state: IApplicationState): TBoardId[] => {
    const answers = getUserQualificationFormAnswers(state);
    if (!answers) return;

    const isSkipped = getUserQualificationFormStatus(state) === EUserMetaQualificationFormStatus.SKIPPED;

    let key: string;
    if (answers['templates_help_func'] && answers['templates_help_func'].key) {
        key = answers['templates_help_func'].key;
    } else if (answers['templates_help_role'] && answers['templates_help_role'].key) {
        key = isSkipped ? 'other' : answers['templates_help_role'].key;
    } else if (answers['templates_help_project'] && answers['templates_help_project'].key) {
        key = answers['templates_help_project'].key;
    }

    if (isObject(TEMPLATES_SETS[key])) {
        const roleKey = answers['templates_help_role'] && answers['templates_help_role'].key;
        const boardIdsSet = TEMPLATES_SETS[key] as TQualificationTemplatesSet;
        return boardIdsSet[roleKey] as TBoardId[];
    } else {
        return [TEMPLATES_SETS[key]] as TBoardId[];
    }
}
